import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import { Roles } from '../../../core/util';
import ImagePreview from '../../../core/layout/ImagePreview';

const CourseList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      ...[
        {
          label: 'Order',
          path: 'order',
          width: '75px',
        },
        {
          label: 'Academic Plan',
          path: 'academicPlan.name',
          width: '100px',
        },
        {
          label: 'Name',
          path: 'name',
        },
        {
          label: 'First review',
          path: 'disableFirstReview',
          width: '100px',
          render: (cell) => (cell ? 'Disabled' : 'Enabled'),
        },
        {
          label: 'Second review',
          path: 'disableSecondReview',
          width: '110px',
          render: (cell) => (cell ? 'Disabled' : 'Enabled'),
        },
      ],
      ...([Roles.ADMIN, Roles.CONTENT_ADMIN].includes(localStorage.role)
        ? [
            {
              label: 'Distributor',
              path: 'distributor.name',
            },
          ]
        : []),
      ...[
        {
          label: 'Actions',
          path: 'action',
          width: '105px',
          align: 'center',
          render: (cell, row) => {
            return (
              <div style={{ display: 'flex', columnGap: 4 }}>
                {row.iconUrl && <ImagePreview src={row.iconUrl} />}
                {row.distributor && <Button icon="delete" onClick={() => props.onDelete(row)} />}
                <Button icon="edit" onClick={() => browserHistory.push(`/courses/${row.id}`)} />
              </div>
            );
          },
        },
      ],
    ]}
    rows={props.courses}
    pagination={props.pagination}
    onChange={props.onChange}
  />
);

CourseList.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  fetching: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CourseList;
